import { FormControl, AbstractControl } from '@angular/forms';
import { Locale } from '@model';

export interface LocaleValidationResult {
  shouldSetErrors: boolean;
  shouldClearErrors: boolean;
  shouldExpandPanel: boolean;
}

export function validateLocaleChanges(
  currentLocales: Locale[],
  previousLocales: Locale[],
  displayLabelsValue: Record<string, string>,
): LocaleValidationResult {
  const localesWereAdded = currentLocales.length > previousLocales.length;
  const localesWereRemoved = currentLocales.length < previousLocales.length;

  if (localesWereAdded) {
    return {
      shouldSetErrors: true,
      shouldClearErrors: false,
      shouldExpandPanel: true,
    };
  }

  if (localesWereRemoved) {
    const allLocalesHaveValues = currentLocales.every(
      (locale) => displayLabelsValue?.[locale.localeName] && displayLabelsValue[locale.localeName].trim(),
    );

    return {
      shouldSetErrors: !allLocalesHaveValues,
      shouldClearErrors: allLocalesHaveValues,
      shouldExpandPanel: !allLocalesHaveValues,
    };
  }

  return {
    shouldSetErrors: false,
    shouldClearErrors: false,
    shouldExpandPanel: false,
  };
}

export function applyLocaleValidationResult(
  result: LocaleValidationResult,
  multiLocaleControl: AbstractControl | null | undefined,
  displayLabelsControl: AbstractControl | null | undefined,
): void {
  if (!multiLocaleControl || !displayLabelsControl) {
    return;
  }

  if (result.shouldSetErrors) {
    multiLocaleControl.markAsDirty();
    multiLocaleControl.setErrors({ supportedLocalesChanged: true });
    multiLocaleControl.markAsTouched();

    displayLabelsControl.setErrors({ supportedLocalesChanged: true });
    displayLabelsControl.markAsTouched();
  }

  if (result.shouldClearErrors) {
    multiLocaleControl.setErrors(null);
    displayLabelsControl.setErrors(null);
    displayLabelsControl.markAsTouched();
  }
}
